module.exports = __webpack_public_path__ + "img/comparison-product-product.64e03485.png";